const docXlsIcon = `
    <?xml version="1.0" encoding="UTF-8"?>
    <svg width="18px" height="22px" viewBox="0 0 18 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
        <title>file-excel-1</title>
        <desc>Created with Sketch.</desc>
        <g id="E-commerce" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="DB-E-commerce---orders" transform="translate(-1135.000000, -287.000000)">
                <g id="BTN" transform="translate(1110.000000, 278.000000)">
                    <g id="file-excel-1" transform="translate(24.000000, 10.000000)">
                        <g id="Outline_Icons" transform="translate(1.666667, 0.000000)" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round">
                            <g id="Group">
                                <g id="Path">
                                    <polygon points="16.25 19.5833333 0.416666667 19.5833333 0.416666667 0.416666667 11.25 0.416666667 16.25 5.41666667"></polygon>
                                    <polyline points="11.25 0.416666667 11.25 5.41666667 16.25 5.41666667"></polyline>
                                </g>
                                <polyline id="Path" points="10 15.4166667 7.91666667 15.4166667 7.91666667 11.25"></polyline>
                                <path d="M11.8833333,14.3816667 C11.9175,14.9591667 12.3666667,15.4166667 12.9166667,15.4166667 C13.4883333,15.4166667 13.95,14.9216667 13.95,14.3108333 C13.95,13.4108333 13.0966667,13.385 12.9158333,13.3333333 C12.735,13.28 11.8816667,13.2533333 11.8816667,12.3533333 C11.8816667,11.7441667 12.3458333,11.25 12.9166667,11.25 C13.465,11.25 13.9141667,11.7075 13.9483333,12.2833333" id="Path"></path>
                                <g transform="translate(2.500000, 10.833333)" id="Path">
                                    <path d="M0.416666667,0.416666667 L2.91666667,4.58333333"></path>
                                    <path d="M2.91666667,0.416666667 L0.416666667,4.58333333"></path>
                                </g>
                            </g>
                        </g>
                        <g id="Invisible_Shape">
                            <rect id="Rectangle" x="0" y="0" width="20" height="20"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
    `;

export default docXlsIcon;
